import React, { useEffect, useRef } from "react";
import translate from "@/utils/translate";

 

export default function SmallModal({
    isModal,
    closeModal,
    title,
    actionButtonTitle,
    dismissButtonTitle,
    onSubmit,
    children,
    processing,
    size = "md", // sm, md, lg
    hideActionButton = false,
    hideDismissButton = false,
}) {
    const modalRef = useRef(null);

    // إغلاق المودال عند الضغط على Escape
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape" && isModal) {
                closeModal(false);
            }
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isModal, closeModal]);

    // منع التمرير في الخلفية عند فتح المودال
    useEffect(() => {
        if (isModal) {
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "15px";
            // التركيز على المودال
            if (modalRef.current) {
                modalRef.current.focus();
            }
        } else {
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
        }

        return () => {
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
        };
    }, [isModal]);

    // تحديد حجم المودال
    const getModalSizeClass = () => {
        switch (size) {
            case "sm":
                return "apeex-modal-sm";
            case "lg":
                return "apeex-modal-lg";
            default:
                return "apeex-modal-md";
        }
    };

    if (!isModal) return null;

    return (
        <div
            className="apeex-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="apeex-modal-title"
            ref={modalRef}
            tabIndex={-1}
        >
            <div className="apeex-modal-overlay" onClick={() => closeModal(false)} />

            <div className={`apeex-modal-dialog ${getModalSizeClass()}`}>
                <div className="apeex-modal-content">
                    {/* رأس المودال */}
                    <div className="apeex-modal-header">
                        <h5 className="apeex-modal-title" id="apeex-modal-title">
                            {title}
                        </h5>
                        <button
                            onClick={() => closeModal(false)}
                            className="apeex-modal-close"
                            aria-label={translate("Close modal")}
                            type="button"
                        >
                            <i className="fa-regular fa-xmark"></i>
                        </button>
                    </div>

                    {/* جسم المودال */}
                    <div className="apeex-modal-body">{children}</div>

                    {/* تذييل المودال */}
                    {(dismissButtonTitle || actionButtonTitle) && !(hideActionButton && hideDismissButton) && (
                        <div className="apeex-modal-footer">
                            {dismissButtonTitle && !hideDismissButton && (
                                <button
                                    onClick={() => closeModal(false)}
                                    type="button"
                                    className="apeex-btn apeex-btn-outline"
                                >
                                    {dismissButtonTitle}
                                </button>
                            )}
                            {actionButtonTitle && !hideActionButton && (
                                <button
                                    type="submit"
                                    className="apeex-btn apeex-btn-primary"
                                    disabled={processing}
                                    onClick={onSubmit}
                                >
                                    {processing ? (
                                        <>
                                            <span className="apeex-spinner">
                                                <i className="fa-regular fa-spinner fa-spin"></i>
                                            </span>
                                            {translate("Processing...")}
                                        </>
                                    ) : (
                                        actionButtonTitle
                                    )}
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}